import Enum from "../../../../../../enums/Enum";

const BMIEnum = new Enum({
        OVERWEIGHT: {name: "Overweight"},
        UNDERWEIGHT: {name: "Underweight"},
        NORMAL: {name: "Normal"},
        OBESE: {name: "Obese"}
});

export default BMIEnum;